import { connect } from 'react-redux';
import { registerPlugin } from '../actions/';
import App from '../components/App';

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    registerPlugin: () => {
      dispatch(registerPlugin());
    },
  };
};

const AppRedux = connect(mapStateToProps, mapDispatchToProps)(App);

export default AppRedux;
